module.exports = __webpack_public_path__ + "static/ogw-878d04369a5148194e8084003c3dc231.jpg";